import { defineStore } from 'pinia'

export const useClienteAuthStore = defineStore('clienteAuth', {
  state: () => ({
    token: '',
    user: null,
    tokenExpiry: null
  }),
  persist: true,
  getters: {
    isAuthenticated: (state) => {
      if (!state.token) return false
      if (state.tokenExpiry && Date.now() > state.tokenExpiry) {
        return false
      }
      return true
    },
    getToken: (state) => () => state.token,
    getUser: (state) => () => state.user
  },
  actions: {
    setAuth(data) {
      this.token = data.token
      this.user = data.user
      // Token válido por 2 horas
      this.tokenExpiry = Date.now() + (2 * 60 * 60 * 1000)
    },
    logout() {
      this.token = ''
      this.user = null
      this.tokenExpiry = null
    }
  }
})
